// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    JW_VIDEO_LOADING() {
      return {
        isLoading: true
      };
    },
    JW_VIDEO_LOADED() {
      return {
        isLoading: false,
        data: action.jwVideo
      };
    },
    JW_VIDEO_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.jwVideo.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
